export const me = /* GraphQL */ `
  query Me {
    me {
      id
      createdAt
      updatedAt
      cognitoUserId
      country
      state
      whatsappNumber
      timeZone
      admin {
        id
        createdAt
        updatedAt
        isActive
        lastSeenOnline
      }
    }
  }
`;
